export function makeInjectionKey() {
    return Symbol();
}
